import { render, staticRenderFns } from "./HelpDocuments.vue?vue&type=template&id=99e1fa82&scoped=true"
import script from "./HelpDocuments.vue?vue&type=script&lang=js"
export * from "./HelpDocuments.vue?vue&type=script&lang=js"
import style0 from "./HelpDocuments.vue?vue&type=style&index=0&id=99e1fa82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e1fa82",
  null
  
)

export default component.exports